import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { CONSTANTS, EMPTY_ARRAY, EMPTY_STRING } from '../constants/Constants';
const {
  ACTIONS
} = CONSTANTS;
const initialState = {
  brands: [],
  supportBrands: [],
  supportForms: [],
  users: [],
  groups: [],
  loading: false,
  supportGroup: [],
  email: '',
  userDetails: {},
  isFetchApiCalled: false,
  isPartnerSite: false,
  chatS3Url: '',
  notifications: [],
  hasMore: true,
  notificationLoading: false,
  notificationFilter: {},
  unreadNotifications: EMPTY_ARRAY,
  unreadNotificationsCount: 0,
  todos: [],
  todoLoading: false,
  ticketFields: {},
  ticketLoading: {
    createTicket: false,
    supportForm: false,
    ticketFields: false,
    ticketCreationFields: false,
    supportBrands: false,
    userDetails: false
  },
  ticketDrawerApiStatus: false,
  pusherCred: {}
};

/* - Reducer for cards.
 * @params
 *  - prevState - object
 *  - action - object
 * @return
 *  - state - object
 */
export default ((prevState, action) => {
  const state = prevState || initialState;
  switch (action.type) {
    case ACTIONS.SET_BRANDS:
      return _objectSpread(_objectSpread({}, state), {}, {
        brands: action.payload || []
      });
    case ACTIONS.SET_SUPPORT_BRANDS:
      return _objectSpread(_objectSpread({}, state), {}, {
        supportBrands: action.payload || []
      });
    case ACTIONS.SET_TICKET_FIELDS:
      return _objectSpread(_objectSpread({}, state), {}, {
        ticketFields: action.payload || {}
      });
    case ACTIONS.SET_TICKET_CREATION_FIELDS:
      return _objectSpread(_objectSpread({}, state), {}, {
        ticketCreationFields: action.payload || {}
      });
    case ACTIONS.SET_TICKET_LOADER:
      return _objectSpread(_objectSpread({}, state), {}, {
        ticketLoading: _objectSpread(_objectSpread({}, state.ticketLoading), action.payload)
      });
    case ACTIONS.SET_TICKET_DRAWER_API:
      return _objectSpread(_objectSpread({}, state), {}, {
        ticketDrawerApiStatus: action.payload || false
      });
    case ACTIONS.SET_SUPPORT_FORMS:
      return _objectSpread(_objectSpread({}, state), {}, {
        supportForms: action.payload || []
      });
    case ACTIONS.SET_REQUESTERS:
      return _objectSpread(_objectSpread({}, state), {}, {
        users: action.payload || []
      });
    case ACTIONS.SET_GROUPS_LOOKUP:
      return _objectSpread(_objectSpread({}, state), {}, {
        groups: action.payload || []
      });
    case ACTIONS.SET_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: action.payload || false
      });
    case ACTIONS.SET_EMAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        email: action.payload || ''
      });
    case ACTIONS.FETCH_GET_USER_DETAILS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        userDetails: action.payload.data,
        isPartnerSite: action.payload.partner_site !== undefined,
        isFetchApiCalled: true
      });
    case ACTIONS.FETCH_GET_USER_DETAILS_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        error: action.payload,
        isFetchApiCalled: false
      });
    case ACTIONS.FETCH_UPDATE_USER_DETAILS_SUCCESS:
      {
        const {
          userDetails
        } = state;
        return _objectSpread(_objectSpread({}, state), {}, {
          userDetails: _objectSpread(_objectSpread({}, userDetails), action.payload),
          isFetchApiCalled: false
        });
      }
    case ACTIONS.FETCH_UPDATE_USER_DETAILS_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        error: action.payload,
        isFetchApiCalled: false
      });
    case ACTIONS.RESET_USER_DETAIL_API_EVENT:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchApiCalled: false
      });
    case ACTIONS.SET_CHAT_S3_URL:
      return _objectSpread(_objectSpread({}, state), {}, {
        chatS3Url: action.payload || ''
      });
    case ACTIONS.FETCH_NOTIFICATIONS:
      return _objectSpread(_objectSpread({}, state), {}, {
        notifications: action.payload || []
      });
    case ACTIONS.SET_UNREAD_NOTIFICATIONS_COUNT:
      return _objectSpread(_objectSpread({}, state), {}, {
        unreadNotificationsCount: action.payload || EMPTY_STRING
      });
    case ACTIONS.HAS_MORE_NOTIFICATION:
      return _objectSpread(_objectSpread({}, state), {}, {
        hasMore: action.payload || false
      });
    case ACTIONS.NOTIFICATION_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        notificationLoading: action.payload || false
      });
    case ACTIONS.NOTIFICATION_FILTER:
      return _objectSpread(_objectSpread({}, state), {}, {
        notificationFilter: action.payload || {}
      });
    case ACTIONS.SET_TODO:
      return _objectSpread(_objectSpread({}, state), {}, {
        todos: action.payload || []
      });
    case ACTIONS.SET_FETCH_TODO_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        todoLoading: action.payload || false
      });
    case ACTIONS.SET_PUSHER_CRED:
      return _objectSpread(_objectSpread({}, state), {}, {
        pusherCred: action.payload || {}
      });
    default:
      return state;
  }
});